export default __webpack_public_path__ + "static/media/Abhinav Srivastava.0284b4b2.jpg";